module.exports = __webpack_public_path__ + "static/user-9ede55bb0e147609471716f731548a80.svg";